import { useMutation } from "react-query";

import { CreateCorporationBody } from "@bcasmart/doxecure-commons/doxecureClientTypes";

import { createCorporation } from "@services/corporations.service";

const useCreateCorporation = () => useMutation((values: CreateCorporationBody) => createCorporation(values));

export default useCreateCorporation;
